import React from 'react';
import PropTypes from 'prop-types';
import { checkSetState } from '@teammo/teammo-general-utils';

export default class Tbody extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    name: PropTypes.string,
    foundText: PropTypes.string,
    showNoRows: PropTypes.bool,
  };

  static defaultProps = {
    children: undefined,
    name: undefined,
    foundText: 'found',
    showNoRows: undefined,
  };

  state = {
    children: this.props.children || [],
    showNoRows: this.props.showNoRows || false,
  };

  UNSAFE_componentWillReceiveProps(newProps) {
    this.setState(checkSetState(this.props, newProps));
  }

  render() {
    if (this.state.showNoRows || this.state.children.length === 0) {
      const displayString = `No ${this.props.name} ${this.props.foundText}`;
      return (
        <div className="row content-row with-margin-bottom">
          <div className="col text-center text-grey">{displayString}</div>
        </div>
      );
    }
    return <div className="content-body">{this.state.children}</div>;
  }
}
